module.exports = "pegasus_template/assets/finability-card.png";